export default class EshopError {
  type: string;
  title: string;
  requestId: string;

  constructor(type: string) {
    this.type = type;
  }
}
